import axios from "axios";
import { Base_URL } from "../url";

export const saveMerchant = async (merchantData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/MerchantMaster/CreateMerchant?UserName=${userName}`,
      merchantData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving merchant details!";
  }
};
export const fetchAllVendors = async () => {
  const res = await axios.get(`${Base_URL}/VendorMaster`);
  return res.data;
};
export const saveVendor = async (vendorData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/VendorMaster/PostVendor?userId=${userId}`,
      vendorData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving vendor:", error);
    throw error.response ? error.response.data : error;
  }
};
// Get vendor by ID
export const updateVendor = async (vendorCode, vendorData, userId) => {
  try {
    // Make sure to include userId in the query string as your API expects
    const response = await fetch(
      `${Base_URL}/VendorMaster/PutVendor/${vendorCode}?userId=${userId}`, 
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vendorData)
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating vendor:', error);
    throw error;
  }
};

export const getVendorById = async (vendorCode) => {
  try {
    const response = await fetch(`${Base_URL}/VendorMaster/${vendorCode}`);

    console.log(response.data);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Vendor not found');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching vendor:', error);
    throw error;
  }
};